import { joinClassNames } from "@common/lib/util"
import Svg from "@common/svg"
import { RTable } from "@common/table/types"
import React from "react"

const ExpandAllButton = ({ table }: { table: RTable }) => {
  const isAllRowsExpanded = table.getIsAllRowsExpanded()
  if (!table.getCanSomeRowsExpand()) return null
  return (
    <button
      onClick={() => table.toggleAllRowsExpanded(!isAllRowsExpanded)}
      className="mx-auto"
    >
      <Svg
        name="arrow-double-right"
        classes={joinClassNames(
          "w-4 h-4 cursor-pointer mr-1 text-gray-600 transform  duration-150 ease-in-out  ",
          isAllRowsExpanded ? "rotate-90" : "rotate-0"
        )}
      />
    </button>
  )
}

export default ExpandAllButton
